import React, {useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxMark from '../../util/remote/ajaxMark';
import { useMarks } from '../../DataStore/MarksContext';

const AlertDeleteMark = ({record, handleClose}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const {getOrganisedMarks} = useMarks();


   if (!record) return null;
  
   
     const confirm=async()=>{
       setLoading(true);
        const server_response = await ajaxMark.removeStudent(record.mark.id);
         setLoading(false);
        if(server_response.status==="OK"){
            getOrganisedMarks();
            // handleClose();
             setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }

        handleClose();
    }

    return (
        <BsModal
            show={true}
            onClose={handleClose}
            title="Remove Student"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Remove
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>{`Are you sure you want to remove ${record.student.last_name} ${record.student.first_name} ( ${record.student.reg_no}) from the marksheet ?`}</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>This action is not reversible.
                </p>
           
            </div>
          

        </BsModal>
    );
};

export default AlertDeleteMark;
